<template>
	<section class="small-12 propertyImages" v-if="property">
		<div class="small-12 wrap" v-if="images.length > 0">
			<div class="small-12 large-4 columns thumbs">
				<ul class="small-12 flex">
					<li class="small-12 active">
						<picture class="small-12 flex borderRadius8" :style="'background:url(' + property.links.media[0] + ') no-repeat center/cover;'"></picture>
					</li>
					<li class="small-12">
						<picture class="small-12 flex borderRadius8" :style="'background:url(' + property.links.media[2] + ') no-repeat center/cover;'"></picture>
					</li>
					<li class="small-12 moreImages">
						<picture class="small-12 flex borderRadius8" :style="'background:url(' + property.links.media[1] + ') no-repeat center/cover;'">
							<figure class="small-12 flex justify-center vertical-align">
								<i class="material-icons-outlined">image</i>
								14
							</figure>
						</picture>
					</li>
				</ul>
			</div>
			<div class="small-12 large-8 imagePreview" v-if="selected_image">
				<picture class="small-12 flex borderRadius8 justify-right" :style="imagePreviewStyle">
					<span class="badge borderRadius50 flex vertical-align justify-center">
						1/14
					</span>
				</picture>
			</div>
		</div>
		<div class="small-12 emptyResults" v-else>
			<picture class="small-12 flex justify-center">
				<img width="400" :src="empty_image" alt="Taxes Document">
			</picture>
			<h6 class="small-12 text-center">
				Images not found
			</h6>
			<p class="small-12 text-center">
				Images for this property have not been added yet.
			</p>
		</div>
	</section>
</template>
	
<script>

	// Import firebase
	import { propertiesModel } from '@/firebase/firebase-config'	

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PropertyImages',

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			property: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fhouse-images.svg?alt=media&token=bb8012e9-2256-4801-b184-a1cd7bb8adbe',
			selected_image: null,
			images: []

		}),

		/*
		**  Watch em'
		*/

		watch: {

			property: {

				immediate: true, // Load on created
				handler(property) {

					// Get the images
					if (property) this.getImages(); 

				}

			}

		},

		/*
		**  Do this first
		*/

		mounted() {

			// Set the selected image
			this.setSelectedImage();

		},

		/*
		**  Set up the methods
		*/

		methods: {

			setSelectedImage: function() {

				// Set the prop
				this.selected_image = this.property.links.media[0];

			},

			getImages: function() {

				// Get the images
				propertiesModel.doc(this.property.id).collection('media').where('meta.deleted_at', '==', null).get()
				.then(snapshot => {

					if (snapshot.empty) return;

					snapshot.forEach(doc => {

						// Add to the images
						this.images.push(doc.data());

					});

				})
				.catch(error => {

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Property Details - Get Images',
						errorType: 'Firestore Database',
						section: 'Property',
						component: 'PropertyImages',
						error: error
					});

				});

			}

		},

		/*
		**  Set the computed props
		*/

		computed: {

			imagePreviewStyle: function() {

				return 'background:url(' + this.selected_image + ') no-repeat center/cover';

			}

		}

	}

</script>